import { Controller } from "@hotwired/stimulus";

/*
 * Overrides an input's placeholder at the md breakpoint and up.
 *
 * The element's existing placeholder attribute is the base (mobile) value, and
 * the data-placeholder-md replaces it at md (768px) and above — same mobile-
 * first convention as Tailwind.
 *
 * Usage:
 *
 *   <%= f.search_field :foo,
 *         placeholder: "Mobile hint",
 *         data: {
 *           controller: "placeholder",
 *           placeholder_md: "Desktop hint"
 *         } %>
 */
export default class extends Controller {
  connect() {
    this.originalPlaceholder = this.element.placeholder;
    this.mql = window.matchMedia("(min-width: 768px)");
    this.update();
    this.mql.addEventListener("change", this.update);
  }

  disconnect() {
    this.mql.removeEventListener("change", this.update);
  }

  update = () => {
    const { placeholderMd } = this.element.dataset;
    this.element.placeholder =
      this.mql.matches && placeholderMd ? placeholderMd : this.originalPlaceholder;
  };
}
